import { IInventoryAdvancePaymentPaginatedListData } from '@/services/inventory-advance-payment';
import {
  InventoryAdvancePayment,
  InventoryAdvancePaymentLine
} from '../inventoryadvancepayment';
import {
  IInventoryAdvancePaymentData,
  IInventoryAdvancePayment,
  IInventoryAdvancePaymentLineData,
  IInventoryAdvancePaymentLine,
  InventoryAdvancePaymentPaymentType
} from '../inventoryadvancepayment.types';

export const mockInventoryAdvancePaymentsData = (): IInventoryAdvancePaymentData[] => [
  {
    id: 1,
    status: {
      value: 0,
      display_name: 'Draft'
    },
    owner: {
      first_name: 'Lamar',
      last_name: 'Falconer',
      email: 'lfalconer@gmail.com'
    },
    amount: 100,
    payment: InventoryAdvancePaymentPaymentType.CARD,
    currency: {
      id: 1,
      code: 'CAD',
      description: 'Canadian Dollar'
    },
    lines: [
      {
        id: 1,
        item: 'Tablet PC',
        description: 'Tablet PC',
        total_price: 399.98,
        department: {
          id: 1,
          code: '304',
          name: 'IT'
        },
        account: {
          id: 1,
          code: '123456',
          name: 'Cash',
          departments: [
            {
              id: 1,
              code: '304',
              name: 'IT'
            }
          ]
        }
      },
      {
        id: 2,
        item: 'Scanner',
        description: 'Scanner',
        total_price: 59.0,
        department: {
          id: 1,
          code: '304',
          name: 'IT'
        },
        account: {
          id: 1,
          code: '123456',
          name: 'Cash',
          departments: [
            {
              id: 1,
              code: '304',
              name: 'IT'
            }
          ]
        }
      }
    ],
    created_at: '2021-04-28T17:35:47.304319Z',
    updated_at: '2021-04-28T17:37:43.697225Z'
  },
  {
    id: 2,
    status: {
      value: 0,
      display_name: 'Draft'
    },
    owner: {
      first_name: 'Lamar',
      last_name: 'Falconer',
      email: 'lfalconer@gmail.com'
    },
    amount: 99,
    payment: 0,
    currency: {
      id: 2,
      code: 'USD',
      description: 'US Dollar'
    },
    lines: [],
    created_at: '2021-04-29T01:02:02.729158Z',
    updated_at: '2021-04-29T01:02:02.729201Z'
  }
];

export const mockInventoryAdvancePayments = (
  data: IInventoryAdvancePaymentData[] = mockInventoryAdvancePaymentsData()
): IInventoryAdvancePayment[] =>
  data.map(item => new InventoryAdvancePayment(item));

export const mockInventoryAdvancePaymentLinesData = (): IInventoryAdvancePaymentLineData[] => [
  {
    id: 1,
    item: 'Tablet PC',
    description: 'Tablet PC',
    total_price: 399.98,
    department: {
      id: 2,
      code: '201',
      name: 'Engineering'
    },
    account: {
      id: 2,
      code: '654321',
      name: 'Accounts Receivable',
      departments: [
        {
          id: 2,
          code: '201',
          name: 'Engineering'
        }
      ]
    }
  },
  {
    id: 2,
    item: 'Scanner',
    description: 'Scanner',
    total_price: 59.0,
    department: {
      id: 2,
      code: '201',
      name: 'Engineering'
    },
    account: {
      id: 2,
      code: '654321',
      name: 'Accounts Receivable',
      departments: [
        {
          id: 2,
          code: '201',
          name: 'Engineering'
        }
      ]
    }
  }
];

export const mockInventoryAdvancePaymentLines = (
  data: IInventoryAdvancePaymentLineData[] = mockInventoryAdvancePaymentLinesData()
): IInventoryAdvancePaymentLine[] =>
  data.map(item => new InventoryAdvancePaymentLine(item));

export const mockInventoryAdvancePaymentPaginatedData = (): IInventoryAdvancePaymentPaginatedListData => {
  return {
    count: mockInventoryAdvancePaymentsData().length,
    next: '',
    previous: '',
    results: mockInventoryAdvancePaymentsData()
  };
};
